export class CustomerProjectDrillingOptions {
    static drillingType = ['Kwaliteitsboring', 'Constructieboring', 'DLC boring'];
    static foundationType = ['Zand', 'Gebonden', 'Ongebonden', 'Elders'];
}
